import { ControlDataTypeKey } from "./control-data-type-key";
const TextInputControlDataTypeKey = ControlDataTypeKey;
const TextInputControlDataTypeValueV1 = "text-input::v1";
const TextInputControlType = "makeswift::controls::text-input";
function TextInput(config = {}) {
  return { type: TextInputControlType, config, version: 1 };
}
export {
  TextInput,
  TextInputControlDataTypeKey,
  TextInputControlDataTypeValueV1,
  TextInputControlType
};
//# sourceMappingURL=text-input.js.map